module.exports = __webpack_public_path__ + "static/media/arrow.f75f6d05.svg";